import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Layout } from "@/components/Layout";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sentMsg, setSentMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSentMsg(data.message);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-5 py-16">
        <div className="border-2 border-white/20 bg-card p-8 brutal-shadow-sm">
          <h1 className="font-display text-4xl mb-1">FORGOT PASSWORD</h1>
          <p className="text-muted-foreground text-sm mb-7">Enter your email and we'll send you a link to choose a new password.</p>
          {sentMsg ? (
            <p data-testid="forgot-sent-message" className="text-sm border border-primary/40 bg-primary/10 p-4">{sentMsg} The link expires in 30 minutes.</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="forgot-email"
                className="w-full bg-background border border-border px-3 py-3 outline-none focus:ring-2 focus:ring-primary text-sm" />
              <button type="submit" disabled={busy} data-testid="forgot-submit"
                className="w-full bg-primary text-primary-foreground font-mono-caps text-xs py-3.5 border border-primary hover-lift disabled:opacity-50">
                {busy ? "..." : "Send Reset Link"}
              </button>
            </form>
          )}
          <p className="mt-6 text-sm text-muted-foreground">
            Signed up with Google? Use "Continue with Google" instead.{" "}
            <Link to="/login" data-testid="forgot-back-to-login" className="text-primary hover:underline font-medium">Back to sign in</Link>
          </p>
        </div>
      </div>
    </Layout>
  );
}
